import { NavLink, Outlet } from 'react-router-dom'
import { PlayerPathProvider } from './PlayerPathProvider'

/**
 * The shell every public view sits in.
 *
 * # Phone first, and not as a courtesy
 *
 * FR-024k and FR-035i: the stroke sheet is consulted before and during play,
 * and the scoreboard is opened on a phone while standing at the simulator.
 * Those are the two views that matter most and the two read in the worst
 * conditions, so the base styles are the phone's and the wider layout is the
 * enhancement — not the other way round.
 *
 * # There is nothing to sign in to
 *
 * Every route under here is public and unauthenticated (FR-047a, FR-047b).
 * There are no member accounts, so the shell has no account menu, no sign-in
 * link and no notion of a current user. The commissioner's console is a
 * separate tree behind its own guard (FR-047c).
 */
export function Layout() {
  return (
    <div className="app">
      <header className="app-header">
        <h1 className="app-title">
          <NavLink to="/">Golf Garage League</NavLink>
        </h1>
        <nav className="app-nav" aria-label="Sections">
          <NavLink to="/standings">Standings</NavLink>
          <NavLink to="/schedule">Schedule</NavLink>
          <NavLink to="/bracket">Playoffs</NavLink>
          <NavLink to="/stats">Stats</NavLink>
          <NavLink to="/players">Players</NavLink>
          <NavLink to="/announcements">News</NavLink>
        </nav>
      </header>
      <main className="app-main">
        <PlayerPathProvider>
          <Outlet />
        </PlayerPathProvider>
      </main>
      <footer className="app-footer">
        <p>Williamsville Golf Garage · everything here is public, and nothing here is editable.</p>
      </footer>
    </div>
  )
}
